<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Button Colors</h4>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="sort" @click="sort('id')">#ID</th>
              <th class="sort" @click="sort('title_en')">Title (English)</th>
              <th class="sort" @click="sort('title_th')">Title (Thai)</th>
              <th class="sort" @click="sort('title_de')">Title (German)</th>
              <th class="sort" @click="sort('title_translatable')">
                Title (Translatable)
              </th>
              <th class="sort" @click="sort('hex_code')">Color</th>
              <th class="sort" @click="sort('hex_code')">Hex Code</th>
              <th class="sort" @click="sort('internal_number')">
                Internal Number (Thai)
              </th>
              <th class="sort" @click="sort('order_color')">Order</th>
              <th class="text-right">
                <button
                  class="btn btn-success"
                  @click="showCreateDialog()"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> New
                  Button Color
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(color, index) in colors" :key="index">
              <td># {{ color.id }}</td>
              <td>{{ color.title_en }}</td>
              <td>{{ color.title_th }}</td>
              <td>{{ color.title_de }}</td>
              <td>{{ color.title_translatable }}</td>
              <td>
                <div
                  class="color-prev"
                  :style="{ backgroundColor: color.hex_code }"
                ></div>
              </td>
              <td>{{ color.hex_code }}</td>
              <td>{{ color.internal_number }}</td>
              <td class="text-center">
                {{ color.order_color ? color.order_color : "-" }}
              </td>
              <td class="text-right">
                <button
                  class="btn btn-primary"
                  @click="showUpdateDialog(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                  Edit
                </button>
                <button
                  class="btn btn-danger"
                  @click="deleteColor(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Button Color
            </h5>
            <h5 class="modal-title text-bold" v-else>New Button Color</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label for="">#ID </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.id"
                placeholder="#ID"
              />
            </div>

            <div class="form-group">
              <label for="">Title (English) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_en"
                placeholder="Title (English)"
              />
              <small v-if="errors.title_en" class="form-text text-danger">{{
                errors.title_en.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label for="">Title (Thai) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_th"
                placeholder="Title (Thai)"
              />
              <small v-if="errors.title_th" class="form-text text-danger">{{
                errors.title_th.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label for="">Title (German) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_de"
                placeholder="Title (German)"
              />
              <small v-if="errors.title_de" class="form-text text-danger">{{
                errors.title_de.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label for="">Title (Translatable) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_translatable"
                placeholder="Title (Translatable)"
              />
              <small
                v-if="errors.title_translatable"
                class="form-text text-danger"
                >{{ errors.title_translatable.join(" ") }}</small
              >
            </div>

            <div class="form-group">
              <label>Hex Code </label>
              <div class="row">
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.hex_code"
                    placeholder="#12DCFF"
                  />
                </div>
                <div class="col-md-2">
                  <v-input-colorpicker
                    v-model="formData.hex_code"
                    @input="handleInput"
                    @change="handleChange"
                    class="btn btn-block"
                  />
                </div>
              </div>
              <small v-if="errors.hex_code" class="form-text text-danger">{{
                errors.hex_code.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label for="">Internal Number </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.internal_number"
                placeholder="1234"
              />
              <small
                v-if="errors.internal_number"
                class="form-text text-danger"
                >{{ errors.internal_number.join(" ") }}</small
              >
            </div>

            <div class="form-group mt-2" v-if="formData.order_color !== 1">
              <label>Order</label>
              <div v-if="editId">
                <toggle-button
                  :sync="true"
                  v-model="changeButtonColorOrder"
                  :value="changeButtonColorOrder"
                />
                Change order
              </div>
              <div class="mt-2">
                <p-radio
                  class="p-default p-curve"
                  color="primary"
                  v-model="formData.button_color_reference_location"
                  value="before"
                  :disabled="!changeButtonColorOrder"
                  >Before</p-radio
                >
                <p-radio
                  class="p-default p-curve"
                  color="primary"
                  v-model="formData.button_color_reference_location"
                  value="after"
                  :disabled="!changeButtonColorOrder"
                  >After</p-radio
                >
              </div>
            </div>

            <div class="form-group" v-if="formData.order_color !== 1">
              <div>
                <v-select
                  :options="colors"
                  v-model="formData.button_color_reference_id"
                  label="title"
                  :disabled="!changeButtonColorOrder"
                  :reduce="(color) => color.id"
                  placeholder="Select a button color"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon"></span>
                    [{{ option.order_color }}] - {{ option.title }}
                  </template>
                </v-select>
                <p v-if="editId && changeButtonColorOrder">
                  Current order {{ formData.order_color }}
                </p>
              </div>
              <small
                v-if="errors.button_color_reference_id"
                class="form-text text-danger"
                >You must select the new color position.</small
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateColor()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createColor()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import InputColorPicker from "vue-native-color-picker";
export default {
  components: {
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      colors: [],
      formData: {},
      editId: null,
      sortType: "asc",
      errors: {},
      background: null,
      changeButtonColorOrder: false,
      isReadOnlyUser: false,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getButtonColors();
  },
  methods: {
    async getButtonColors() {
      try {
        let res = await axios.get("v2/fabrics/button_colors");
        this.colors = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load button colors");
        }
      }
    },

    sort(column) {
      this.sortType = this.sortType == "asc" ? "desc" : "asc";
      this.colors = _.orderBy(this.colors, [column], [this.sortType]);
    },

    showCreateDialog() {
      this.editId = null;
      this.changeButtonColorOrder = true;
      this.errors = {};
      this.formData = {
        button_color_reference_id: null,
        button_color_reference_location: "after",
      };
      show_modal("#modal-box");
    },

    showUpdateDialog(index) {
      var data = this.colors[index];
      this.errors = {};
      this.formData = {
        id: data.id,
        title_en: data.title_en,
        title_th: data.title_th,
        title_de: data.title_de,
        title_translatable: data.title_translatable,
        hex_code: data.hex_code,
        internal_number: data.internal_number,
        order_color: data.order_color,
        button_color_reference_id: null,
        button_color_reference_location: "after",
      };
      this.changeButtonColorOrder = false;
      this.editId = data.id;
      show_modal("#modal-box");
    },

    async createColor() {
      try {
        let res = await axios.post("v2/fabrics/button_colors", {
          ...this.formData,
          button_color_reference_location:
            this.formData.button_color_reference_id === 1
              ? "after"
              : this.formData.button_color_reference_location,
        });
        if (res) {
          this.getButtonColors();
          toastr.success("Button Color Created");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async updateColor() {
      try {
        if (!this.changeButtonColorOrder) {
          delete this.formData.button_color_reference_id;
        }
        let res = await axios.put("v2/fabrics/button_colors/" + this.editId, {
          ...this.formData,
          button_color_reference_location:
            this.formData.button_color_reference_id === 1
              ? "after"
              : this.formData.button_color_reference_location,
        });
        if (res) {
          this.getButtonColors();
          toastr.success("Button Color Updated");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async deleteColor(index) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });
      if (!result.value) {
        return;
      }
      try {
        let data = this.colors[index];
        let res = await axios.delete("v2/fabrics/button_colors/" + data.id);
        if (res) {
          this.getButtonColors();
          toastr.success("Button color #" + data.id + " deleted");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Duplicate ID exist");
        }
      }
    },
    handleInput(hexCode) {
      // This method must be declared because it's required by the color picker library
    },
    handleChange(hexCode) {
      // This method must be declared because it's required by the color picker library
    },
  },
};
</script>
<style scoped>
.icp__input {
  border-radius: 4px;
  background-color: #000 !important;
}
.mt-2 {
  margin-top: 10px;
}
.color-prev {
  height: 50px;
  width: 50px;
  border-radius: 50px;
  margin: 0 auto;
}
</style>
